import request from "@/network/request"

// 山西省人民医院查询订单数据
export function hospitalOrders(data) {
  return request({
    url: `/sclm/apply/app/scan/hospitalOrderRecent`,
    method: 'post',
    data,
  });
}

// 赞皇县医院查询订单数据
export function zhxhospitalOrders(data) {
  return request({
    url: `/sclm/apply/app/scan/z12h45xahospitalOrderRecent`,
    method: 'post',
    data,
  });
}

// 吉县医院查询订单数据
export function jxhospitalOrders(data) {
  return request({
    url: `/sclm/apply/app/scan/ghfghf5xahospitalOrderRecent`,
    method: 'post',
    data,
  });
}

// 长春中医药大学附属第三临床医院查询订单数据
export function cczyydadshospitalOrders(data) {
  return request({
    url: `/sclm/apply/app/scan/xcdxcvxcxahospitalOrderRecent`,
    method: 'post',
    data,
  });
}

// 吉林市儿童医院查询订单数据
export function jlsetyyhospitalOrders(data) {
  return request({
    url: `/sclm/apply/app/scan/wesdssdhospitalOrderRecent`,
    method: 'post',
    data,
  });
}

// 晋中市中医院查询订单数据
export function jzszyyhospitalOrders(data) {
  return request({
    url: `/sclm/apply/app/scan/ghfghf5xaho132323spitalOrderRecent`,
    method: 'post',
    data,
  });
}
